import React from "react";
import { DEFAULT_UI_VIEW } from "../../constants";
import { useLegalTerms } from "../../hooks/useLegalTerms";
import { SchedulerStoreType } from "../../state/scheduler.store";
import { BookingFormType, LegalType } from "../../types";
import { BookingForm } from "./BookingForm";

interface BookingFormWrapperProps {
  meetingLink: SchedulerStoreType["meetingLink"];
  sessionData: SchedulerStoreType["sessionData"];
  handleFormInput: (
    bookingFormData: BookingFormType,
    legal: LegalType[],
    selectedLanguages: Record<string, string>
  ) => void;
  actions: SchedulerStoreType["actions"];
  ui: SchedulerStoreType["ui"];
}

export const BookingFormWrapper: React.FC<BookingFormWrapperProps> = ({
  meetingLink,
  sessionData,
  handleFormInput,
  actions,
  ui
}) => {
  const legal = useLegalTerms();

  return (
    <BookingForm
      formType={
        meetingLink?.roosterLinksMeta?.profileType === "prospect"
          ? "Prospect"
          : "Standalone"
      }
      legal={legal}
      isReschedule={sessionData?.isRescheduleFlow ?? false}
      isAutobook={meetingLink?.type === "rooster"}
      candidateRequiredFields={
        meetingLink?.roosterLinksMeta?.candidateRequiredFields ?? []
      }
      savedFormData={sessionData?.formData ?? {}}
      submitHandler={handleFormInput}
      backHandler={() => {
        actions.setUiState({
          ...ui,
          currentStep: "initial",
          currentView: ui?.currentView ?? DEFAULT_UI_VIEW
        });
      }}
    />
  );
};
